import React, { FC } from 'react';

export interface LassoBoxProps {
  show: boolean;
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}

export const LassoBox: FC<LassoBoxProps> = ({ x1, x2, y1, y2, show }) => {
/*
  const scrollTop =
    window.pageYOffset !== undefined
      ? window.pageYOffset
      : (document.documentElement || document.body.parentNode || document.body).scrollTop;
*/
  return (
    <div
      style={{
        border: '1px dotted #000',
        position: 'absolute',
        left: Math.min(x1, x2),
        //top: Math.min(y1, y2) + scrollTop,
        top: Math.min(y1, y2),
        width: Math.max(x1, x2) - Math.min(x1, x2),
        height: Math.max(y1, y2) - Math.min(y1, y2),
        display: show ? 'block' : 'none',
        zIndex: 9,
      }}
    ></div>
  );
};
